import { render, staticRenderFns } from "./testlist.vue?vue&type=template&id=154428ff&"
import script from "./testlist.vue?vue&type=script&lang=js&"
export * from "./testlist.vue?vue&type=script&lang=js&"
import style0 from "./testlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports